import React from 'react';

import './ProfileWarning.less';

export function ProfileWarning() {
  return (
    <p className="esq_profile_warning">
      Saying &quot;Yes&quot; will add this information to your profile
      {' '}
      <button
        aria-label="You can remove this information by editing your profile."
        className="profile_tooltip"
        data-callout="tooltip"
        title="You can remove this information by editing your profile."
        type="button"
      />
    </p>
  );
}

export default ProfileWarning;
